import React from 'react';
import { View } from 'react-native';

import styleSalesLastXDays from '../../../common/utils/planogramItemStatistics/styleSalesLastXDays';
import { useUserContext } from '../../../common/utils';
import { useThemedStyles } from '../../hooks/useThemedStyles';
import Text from '../../components/text/Text';

const PlanogramItemSalesLastXDays = ({
	salesLast365Days,
	salesLast30Days,
	salesLast14Days,
	salesLast7Days,
	lastProductChangeTime,
	created, // planogramItem.created
	confirmStockLevelsStyle,
	dialogStyle,
}) => {
	const { tenantSettings } = useUserContext();
	const styles = useThemedStyles(createStyles);
	const { planogramItemSalesLastXDaysThresholds, planogramItemDaysSinceLastSale } = tenantSettings;

	const {
		salesLastXDays,
		backgroundStyle,
	} = styleSalesLastXDays({ salesLast365Days, salesLast30Days, salesLast14Days, salesLast7Days, lastProductChangeTime, created, planogramItemSalesLastXDaysThresholds, planogramItemDaysSinceLastSale });

	return (
		<View style={[
			confirmStockLevelsStyle && styles.confirmStockLevels,
			dialogStyle && styles.dialogStyle,
			backgroundStyle.markerColor2 && styles.grey,
			backgroundStyle.planogramRedFooter && styles.red,
			backgroundStyle.planogramAmberFooter && styles.yellow,
			backgroundStyle.planogramGreenFooter && styles.green,
		]}>
			<Text style={[
				styles.textCenter,
				dialogStyle && styles.dialogTextStyle,
				backgroundStyle.markerColor2 && styles.greyText,
				backgroundStyle.planogramRedFooter && styles.redText,
				backgroundStyle.planogramAmberFooter && styles.yellowText,
				backgroundStyle.planogramGreenFooter && styles.greenText,
			]}>
				{salesLastXDays || 0}
			</Text>
		</View>
	);
};

// Box tones follow the 30-day sales thresholds (red / amber / green / none).
const createStyles = ({ ui: { colors, type, radius } }) => ({
	confirmStockLevels: {
		minWidth: 24,
		paddingVertical: 1,
		paddingHorizontal: 6,
		borderWidth: 1.5,
		borderRadius: radius.tag,
		borderColor: colors.icon,
	},
	dialogStyle: {
		borderWidth: 1.5,
		borderRadius: radius.tag,
		borderColor: colors.icon,
		backgroundColor: colors.card,
		minWidth: 44,
		minHeight: 36,
		paddingHorizontal: 8,
		justifyContent: 'center',
	},
	textCenter: {
		...type.bodySmallStrong,
		color: colors.text,
		textAlign: 'center',
	},
	dialogTextStyle: {
		...type.body,
	},
	red: {
		borderColor: colors.danger,
	},
	redText: {
		color: colors.danger,
	},
	yellow: {
		borderColor: colors.warning,
	},
	yellowText: {
		color: colors.warning,
	},
	green: {
		borderColor: colors.success,
	},
	greenText: {
		color: colors.success,
	},
	grey: {
		borderColor: colors.borderStrong,
	},
	greyText: {
		color: colors.textSecondary,
	},
});


export default PlanogramItemSalesLastXDays;
